import { render, staticRenderFns } from "./BzTags.vue?vue&type=template&id=a0325c54&scoped=true&"
import script from "./BzTags.vue?vue&type=script&lang=js&"
export * from "./BzTags.vue?vue&type=script&lang=js&"
import style0 from "./BzTags.vue?vue&type=style&index=0&id=a0325c54&scoped=true&lang=css&"
import style1 from "./BzTags.vue?vue&type=style&index=1&id=a0325c54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0325c54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VContainer,VIcon,VRow,VSpacer})
